module.exports = __webpack_public_path__ + "static/pool-s-7bd0eec2b02001bfefc036bdad1d8882.svg";